<template>
  <div class="feedback">
    <div class="country-title">所属国家</div>
    <div class="coun-box">
      <country-box
        :value="advice.visa_country_id"
        :countryArr="countryArr"
        @input="advice.visa_country_id = arguments[0]"
      ></country-box>
    </div>
    <div class="advice-title">建议/错误描述</div>
    <div class="advice-box">
      <textarea
        v-model="advice.content"
        rows="8"
        placeholder="请输入您的建议"
        maxlength="500"
      ></textarea>
    </div>
    <div class="phone-title">电话/邮箱</div>
    <div class="phone-box">
      <input type="text" v-model="advice.contact" maxlength="50" />
    </div>
    <div class="submit" @click="submitAdvice()">提交</div>
  </div>
</template>

<script>
import utils from '../services/tools.js';
import FeedbackService from '../services/feedbackService.js';
import toast from '../services/toast.js';

import countryBox from '../components/country-box/CountryBox';

export default {
  name: 'feedback',
  data() {
    return {
      field: {},
      feedbackService: new FeedbackService(this.$http),
      advice: {
        content: '',
        contact: '',
        visa_country_id: this.$route.query.visa_country_id,
      },
      countryArr: [],
      isH5: false,
    };
  },
  components: {
    countryBox,
  },
  methods: {
    submitAdvice() {
      const { content, contact, visa_country_id: visaCountryId } = this.advice;
      if (!content) {
        toast.show('请填写建议/错误描述');
        return;
      }
      if (!contact) {
        toast.show('请填写电话/邮箱');
        return;
      }
      if (!visaCountryId) {
        toast.show('请选择所属国家');
        return;
      }

      this.feedbackService
        .submitAdviceForFeedback(content, contact, visaCountryId)
        .then(() => {
          toast.show('提交成功');
          setTimeout(() => {
            if (utils.isWxa()) {
              wx.miniProgram.navigateBack();
            } else if (this.isH5) {
              window.history.back();
            } else {
              utils.getBridge((bridge) => {
                bridge.callHandler('dimiss', {}, () => {});
              });
            }
          }, 1000);
        })
        .catch(() => {
          toast.show('提交建议失败');
        });
    },
    /**
     * 获取用户编号
     */
    getUID() {
      if (!this.$route.query.visa_country_id) {
        toast.show('缺少参数');
        return;
      }
      this.advice.contact = this.$route.query.mobile_phone;
      this.advice.visa_country_id = parseInt(this.$route.query.visa_country_id);
      this.isH5 = this.$route.query.is_h5;
    },

    /**
     * 获取邀请信息
     */
    getFeedbackInfo() {
      const _this = this;
      this.feedbackService
        .getVisaCountryTotalQuery({})
        .then((data) => {
          _this.countryArr = data.body.body.page_data;
        })
        .catch(() => {
          toast.show('获取国家列表失败');
        });
    },

    /**
     * 分享
     */
    share() {
      // if(!this.inviteInfo){
      //   toast.show('获取数据失败');
      //   return;
      // }
      // var me = this;
      // utils.getBridge(function(bridge){
      //   bridge.callHandler("client_share", me.shareDatas[type],function(){});
      // });
    },
  },
  mounted() {
    this.getUID();
    this.getFeedbackInfo();
  },
  created() {
    utils.setTitle('优化建议或纠错');
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1;
}

html,
body {
  height: 100%;
  width: 100%;
  background-color: white;
}

html {
  font-size: 625%;
}

@media screen and (min-width: 404px) {
  html {
    font-size: 690%;
  }
}

body {
  font-family: PingFang SC, Microsoft YaHei, Helvetica, Segoe UI, Lucida Grande,
    Helvetica, Arial, FreeSans, Arimo, Droid Sans, wenquanyi micro hei,
    Hiragino Sans GB, Hiragino Sans GB W3, FontAwesome, sans-serif;
  font-size: 0.16rem;
  color: #444;
  background-color: #fdfdfe;
}

img {
  max-width: 100%;
}

.feedback {
  height: 100%;
  background-color: #ffffff;
  padding: 0.01rem 0.1rem;

  .advice-title,
  .phone-title,
  .country-title {
    font-size: 0.14rem;
    color: #6f6f6f;
    margin-top: 0.2rem;
    margin-bottom: 0.1rem;
  }

  .submit {
    background-color: #ff5a60;
    height: 0.45rem;
    border-radius: 0.03rem;
    text-align: center;
    line-height: 0.45rem;
    color: #ffffff;
    font-size: 0.16rem;
    margin-top: 0.2rem;
  }

  .advice-box {
    textarea {
      resize: none;
      width: 100%;
      border-radius: 0.03rem;
      border-color: #e9e9e9;
      padding: 0.1rem;
      color: #444444;
      -webkit-appearance: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }

  .phone-box {
    input {
      width: 100%;
      border-radius: 0.03rem;
      border: 0.01rem solid #e9e9e9;
      height: 0.45rem;
      outline: none;
      padding-left: 0.1rem;
      font-size: 0.15rem;
      color: #444444;
      -webkit-appearance: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }
}
</style>
